import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import uuid from "vue-uuid";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  uuid,
  render: (h) => h(App),
}).$mount("#app");
